import declare from "dojo/_base/declare";
import QueryFilterController from "./QueryFilterController";
import xml from "csi/xml";

const DataPackageTemplateSheetFilterController = declare(QueryFilterController, {

	/**
	 * For ShapeSizeChart and ShapeSizeChartReview remove "Shape" from type
	*/
	_removeShapeFromType(type: string): string {
		return type.startsWith("Shape") ? type.replace("Shape", "") : type;
	},

	/**
	 * @override
	 * Return contextual datasheet type since Data Packages uses DataSheetQueryFilter
	 */
	_getStartType(): string {
		return this._removeShapeFromType(xml.enumGetText(this.getNode().Type));
	},
});

export = DataPackageTemplateSheetFilterController;
